<template>
  <contents-none
    v-if="productList.length === 0"
    :none-text="$t('search.no_search_results_A19')"
  ></contents-none>
  <products-list
    v-else
    :listTypeBest="true"
    :isCartbuttonVisible="false"
    :productList="productList"
  ></products-list>
</template>

<script>
import NavigationTab from '@/views/base/NavigationTab'
import ContentsNone from '@/views/base/ContentsNone'
import ProductsList from '@/views/shop/ProductsList'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SearchProducts',
  components: {
    NavigationTab,
    ContentsNone,
    ProductsList
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('search', ['productList'])
  },
  methods: {},
  mounted() {
    //this.searchProduct(this.$route.params.query)
  }
}
</script>

<style lang="scss">
.search {
  padding-top: 99px;
  .navigationTab {
    top: 54px;
    height: 100px;
    padding-top: 56px;
  }
  .btMore {
    width: 100%;
    height: 39px;
    padding-top: 1px;
    color: #8b8b91;
    font-size: 14px;
    background-color: #fff;
    overflow: hidden;
    .icon {
      margin: 0 5px 3px 0;
    }
  }
}
</style>
